import { render, staticRenderFns } from "./MsgInbox.vue?vue&type=template&id=404c7f86&scoped=true&"
import script from "./MsgInbox.vue?vue&type=script&lang=ts&"
export * from "./MsgInbox.vue?vue&type=script&lang=ts&"
import style0 from "./MsgInbox.vue?vue&type=style&index=0&id=404c7f86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404c7f86",
  null
  
)

export default component.exports